import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

import { useDataContext } from 'src/context/data';

import Testimonials from 'src/Widget/Conversation/Testimonials/Testimonials';

import { renderCloseIcon } from 'src/utils/iconRenderers';

import { buttonAnimationVariants, contentHolderAnimationVariants } from './animations';

import messageBubblesIconSrc from '../../../assets/message-bubbles.svg';
import avatarImageSrc from '../../../assets/avatar.png';

import dimensionsModule from 'src/utils/styles/_dimensions.module.scss';

/* - - - - - - - - - - - - - - - - - - - - - */

const dimensions = dimensionsModule.locals;

/* - - - - - - - - - - - - - - - - - - - - - */

const COLLAPSED_TESTIMONIAL_WITH_LOGO_WIDTH = window.innerWidth < dimensions.mobileBreakpoint ? 140 : 160;
const COLLAPSED_TESTIMONIAL_WITHOUT_LOGO_WIDTH = window.innerWidth < dimensions.mobileBreakpoint ? 190 : 225;

function Launcher() {
  const {
    appState: {
      widgetIsOpen,
      widgetData: { parameters, config },
    },
    setWidgetOpenedStatus,
    makeWidgetReset,
  } = useDataContext();

  useEffect(() => {
    if (!widgetIsOpen) {
      makeWidgetReset();
    }
  }, [widgetIsOpen]);

  const renderFullWidthContent = () => {
    return (
      <motion.div className="rcw-launcher-content-holder" variants={contentHolderAnimationVariants}>
        {parameters?.collapsedBrandUrl && (
          <div className="rcw-launcher-logo-holder" data-cy="launcher-logo-holder">
            <img src={parameters?.collapsedBrandUrl} alt="Logo" />
          </div>
        )}
        <Testimonials
          maxCollapsedWidth={
            parameters?.collapsedBrandUrl
              ? COLLAPSED_TESTIMONIAL_WITH_LOGO_WIDTH
              : COLLAPSED_TESTIMONIAL_WITHOUT_LOGO_WIDTH
          }
          parameters={parameters}
          dialogConfig={config}
          collapsed
        />
      </motion.div>
    );
  };

  const renderRoundWidthContent = () => {
    if (widgetIsOpen) return renderCloseIcon(parameters.collapsedButtonTextColor);

    return (
      <motion.div className="rcw-launcher-avatar-holder" variants={contentHolderAnimationVariants}>
        <div
          className="rcw-launcher-avatar-message-subicon-holder"
          style={{
            background: Boolean(parameters.collapsedSpeechBalloonColor)
              ? parameters.collapsedSpeechBalloonColor
              : 'red',
          }}
        >
          <img src={messageBubblesIconSrc} alt="Msg" />
        </div>

        <div className="rcw-launcher-avatar-image-wrapper">
          <img className="rcw-launcher-avatar-image" src={avatarImageSrc} alt="Avatar image" />
        </div>
      </motion.div>
    );
  };

  return (
    <div className="rcw-launcher-button-holder">
      <motion.button
        className="rcw-launcher-animated-button"
        style={{ background: parameters.collapsedButtonBackgroundColor, color: parameters.collapsedButtonTextColor }}
        onClick={() => setWidgetOpenedStatus(!widgetIsOpen)}
        initial={false}
        animate={widgetIsOpen ? 'collapsed' : 'fullWidth'}
        variants={buttonAnimationVariants}
        data-cy="launcher-btn"
      >
        {renderRoundWidthContent()}
        {renderFullWidthContent()}
      </motion.button>
    </div>
  );
}

export default Launcher;
